/* eslint-disable import/prefer-default-export */
import types from '../types/types';
import ApiCart from '../../api/Cart/CartApiFL';
import Config from '../../config/config';

export const startGetCart = (cartId, InfoCarrito) => (dispatch) => {
  dispatch({
    type: types.getCart,
    InfoCarrito,
    IdCarrito: cartId,
  });
};

export const getCart = (cartId) => async (dispatch) => {
  const payload = {
    Cliente: Config.api_services.client,
    Pais: 'MEX',
    Ambiente: Config.api_services.environment,
    IdCarrito: cartId,
  };
  const resp = await ApiCart.getCart(payload);
  if (resp.Codigo === 200) {
    dispatch(
      startGetCart(
        resp.InfoCarrito.length ? resp.InfoCarrito[0].idCarrito : 0,
        resp.InfoCarrito
      )
    );
  }
};
